module.exports = __webpack_public_path__ + "img/row-srp-preview-cjdr.4cd8f9c2.png";